import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { TextField } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import FormLabel from "@material-ui/core/FormLabel";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

import useDialogWebFormMultiItems from "../../../core-module/hook/useDialogWebFormMultiItems";

import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
// import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import PasswordTextField from "../CustomInput/PasswordTextField";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "5px",
    fontSize: "18px",
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    ...importedStyle.cardIconTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  labelHorizontal: {
    justifyContent: "center",
    fontSize: "15px",
  },
  outerContainer: {
    marginLeft: "5px",
    marginTop: "20px",
  },
  innerContainer: {
    marginBottom: "0px",
    paddingRight: "2vw",
    paddingLeft: "2vw",
    cursor: "pointer",
  },
  editButton: {
    textAlign: "right",
    margin: "20px",
  },
  resize: {
    fontSize: 19,
  },
};

const MultiItemFormEdit = (props) => {
  const filteredNames = props.myProps.filter((prop) => !prop.disabled);
  const propNames = filteredNames.map((prop) => prop.propName);
  const passThroughProps = filteredNames.map((prop) => prop.passThroughProp);
  const { classes } = props;

  const {
    change,
    getValue,
    getError,
    getLabel,
    getSchema,
    getDropdownOptions,
    submitForm,
    getTextInputValue,
    startForm,
    formIsValid,
    getHelperText,
  } = useDialogWebFormMultiItems(props, propNames);

  const [dialogOpen, setDialogOpen] = useState(props.dialogOpen);

  function onSubmit() {
    props.closeDialog();
    submitForm();
  }

  function cancelDialog() {
    props.closeDialog();
  }

  useEffect(() => {
    if (dialogOpen !== props.dialogOpen) {
      setDialogOpen(props.dialogOpen);

      if (props.dialogOpen === true) {
        startForm();
      }
    }
  }, [props.dialogOpen]);

  function getContent(propName, context, passThroughProps, key) {
    function onChange(e) {
      if (getSchema(propName).type === "bo") {
        change(e.target.checked, propName);
      } else {
        change(e.target.value, propName);
      }
    }
    // function onNumberChange(text) {
    //   const found = text.match(/(-?)(\d*)/);
    //   let sinal = 1;
    //   if (found[1] === '-') {
    //     sinal = -1;
    //   }

    //   if (found[2].length > 0) {
    //     let number = Number(found[2]);
    //     change(sinal * number, propName);
    //   } else {
    //     change(text, propName);
    //   }
    // }
    // function isNumber(passThroughProps) {
    //   if (passThroughProps){
    //     if ( passThroughProps.type == 'number') {
    //       return true;
    //     }
    //   }
    //   return false;
    // }

    switch (getSchema(propName).type) {
      case "so":
        return (
          <Select
            key={key}
            value={this.props.userid}
            onChange={(event) => onChange}
            label={getLabel(propName)}
            inputProps={{
              name: "selectUser",
              id: "selectUser",
            }}
          >
            {getDropdownOptions(propName).map((element, key) => {
              return (
                <MenuItem key={key} value={element}>
                  {getDropdownOptions(propName)[element]}
                </MenuItem>
              );
            })}
          </Select>
        );
      case "bo":
        return (
          <Switch
            key={key}
            {...passThroughProps}
            color="primary"
            checked={getValue(propName)}
            onChange={onChange}
          ></Switch>
        );
      case "oi":
      default:
        if (propName.includes("password")) {
          return (
            <PasswordTextField
              key={key}
              variant="filled"
              autoFocus
              margin="dense"
              passThroughProps={passThroughProps}
              InputProps={{
                classes: {
                  input: classes.resize,
                },
              }}
              InputLabelProps={{ style: { fontSize: 17 } }}
              label={getLabel(propName)}
              fullWidth
              value={getTextInputValue(propName)}
              onChange={onChange}
              error={getError(propName)}
              helperText={getHelperText(propName)}
            />
          );
        } else {
          return (
            <TextField
              key={key}
              variant="filled"
              autoFocus
              margin="dense"
              {...passThroughProps}
              InputProps={{
                classes: {
                  input: classes.resize,
                },
              }}
              InputLabelProps={{ style: { fontSize: 17 } }}
              label={getLabel(propName)}
              fullWidth
              value={getTextInputValue(propName)}
              onChange={onChange}
              error={getError(propName)}
              helperText={getHelperText(propName)}
            />
          );
        }
    }
  }

  return (
    <Dialog open={props.dialogOpen}>
      <GridContainer xs={12} justify="center">
        <GridItem xs={12}>
          <CardHeader color="primary" icon>
            <h4
              style={{ textAlign: "center" }}
              className={classes.cardIconTitle}
            >
              {props.title}
            </h4>
          </CardHeader>
          <GridContainer className={classes.outerContainer} alignItems="center">
            {propNames.map((propName, i) =>
              getSchema(propName).type === "bo" ? (
                <GridItem key={i} xs={12}>
                  <div className={classes.innerContainer}>
                    <GridContainer alignItems="center">
                      <GridItem xs={9}>
                        <FormLabel className={classes.labelHorizontal}>
                          {getLabel(propName)}
                        </FormLabel>
                      </GridItem>
                      <GridItem xs={3}>
                        <h5 className={classes.datainfo}>
                          {getContent(propName, passThroughProps[i], i)}
                        </h5>
                      </GridItem>
                    </GridContainer>
                  </div>
                </GridItem>
              ) : (
                <GridItem key={i} xs={12}>
                  <div className={classes.innerContainer}>
                    <GridContainer alignItems="center">
                      <GridItem xs={12}>
                        <h5 className={classes.datainfo}>
                          {getContent(propName, passThroughProps[i], i)}
                        </h5>
                      </GridItem>
                    </GridContainer>
                  </div>
                </GridItem>
              )
            )}
          </GridContainer>
        </GridItem>
      </GridContainer>
      <DialogActions>
        <Button onClick={cancelDialog} color="primary">
          Cancel
        </Button>
        <Button disabled={!formIsValid} onClick={onSubmit} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default withStyles(styles)(MultiItemFormEdit);
